import { query_dispatcher } from '@/api/client';
import { normalizeSupplierTaxId } from './ApiSupplierRepository';

export interface CustomerSummary {
  id: number;
  cif: string;
  name: string;
  selectorText: string;
  selector_text: string;
}

interface CustomerQueryDispatcher {
  dispatch(queryName: string, parameters: object): Promise<unknown>;
}

const customerName = (customer: any): string => customer.business_name
  || customer.trade_name
  || [customer.name, customer.first_surname, customer.second_surname].filter(Boolean).join(' ');

export class ApiCustomerRepository {
  private customerQueryDispatcher: CustomerQueryDispatcher;

  constructor(customerQueryDispatcher: CustomerQueryDispatcher = query_dispatcher) {
    this.customerQueryDispatcher = customerQueryDispatcher;
  }

  private static parseCustomer(customer: any): CustomerSummary {
    const name = customerName(customer);
    const selectorText = [customer.cif, name].filter(Boolean).join(' - ');
    return {
      id: customer.id,
      cif: customer.cif || '',
      name,
      selectorText,
      selector_text: selectorText,
    };
  }

  async search(companyId: number, searchTerm: string, limit = 30): Promise<CustomerSummary[]> {
    const response: any = await this.customerQueryDispatcher.dispatch('get.facture.e.customers', {
      company_id: companyId,
      search_term: String(searchTerm || '').trim(),
      limit,
    });
    const customerList = Array.isArray(response) ? response : ((response && response.items) || []);
    return customerList.map(ApiCustomerRepository.parseCustomer);
  }

  async findByTaxId(companyId: number, taxId: string): Promise<CustomerSummary[]> {
    const normalizedTaxId = normalizeSupplierTaxId(taxId);
    const customerList = await this.search(companyId, normalizedTaxId);
    return customerList
      .filter(customer => normalizeSupplierTaxId(customer.cif) === normalizedTaxId)
  }
}
